var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-image-view",class:{ __blurred: !_vm.isPublic }},[_c('span',{staticClass:"file-image-view__file-name"},[_vm._v(_vm._s(_vm.separatedFileName.name))]),_c('span',[_vm._v(_vm._s(_vm.separatedFileName.type))])])}
var staticRenderFns = []

export { render, staticRenderFns }